import { P } from 'common/typography'
import { MdLock } from 'react-icons/md'
import styled from 'styled-components'

const SecurePaymentStyled = styled.div`
  margin-top: 16px;
  .credit-cards {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    img {
      margin: 0 4px;
    }
  }
  .lock {
    color: var(--neutral40);
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 25px;
  }
  @media (min-aspect-ratio: 21 / 9) {
    display: none;
  }
`

function SecurePayment() {
  return (
    <SecurePaymentStyled className="secure-payment">
      <div className="lock">
        <MdLock size={24} />
        <p>Pagos encriptados SSL seguros</p>
      </div>
      <div className="credit-cards">
        <img width="34" height="24" src="/images/icons/visa.svg" alt="Tarjetas Visa Aceptadas" />
        <img width="34" height="24" src="/images/icons/master-card.svg" alt="Tarajetas Matercard Aceptadas" />
        <img width="34" height="24" src="/images/icons/amex-card.svg" alt="Tarajetas American Express Aceptadas" />
      </div>
    </SecurePaymentStyled>
  )
}

export default SecurePayment
